import { useContext } from 'react';
import { ModuloContextDataProps } from '../types';
import { ModuloContext } from '../context/ModuloContext';

export const useModulo = (): ModuloContextDataProps =>
  useContext(ModuloContext);
